import TenantReportAvailability from '../security/TenantReportAvailability';
import {
  MessageBar,
  MessageBarType,
  Pivot,
  PivotItem,
  Stack,
  Text,
} from '@fluentui/react';
import { useAtomValue } from 'jotai';
import { currentTenantNameAtom, profileDataAtom } from '../../atoms/authAtoms';
import { toConcreteTenantId } from './pricingSettings';
import TenantPricingOverrides from './TenantPricingOverrides';
import TenantPricingParameters from './TenantPricingParameters';
import TenantSurcharges from './TenantSurcharges';

const Pricing = () => {
  const { currentTenant } = useAtomValue(profileDataAtom);
  const tenantName = useAtomValue(currentTenantNameAtom);
  const tenantId = toConcreteTenantId(currentTenant);

  return (
    <Stack tokens={{ childrenGap: 12 }} styles={{ root: { padding: 10 } }}>
      {tenantId === undefined ? (
        <MessageBar messageBarType={MessageBarType.info}>
          Select a tenant to manage its pricing and report availability.
        </MessageBar>
      ) : (
        <Pivot>
          <PivotItem headerText="Rate overrides" itemKey="rateOverrides">
            <Stack tokens={{ childrenGap: 12 }}>
              <Text variant="large">Tenant pricing overrides</Text>
              <Text>
                Tenant: {tenantName || tenantId}. Overrides replace the global
                rate for the same pricing item, conditions, currency, and dates.
                Tenant discounts and pricing tiers still apply.
              </Text>
              <TenantPricingOverrides
                key={tenantId}
                tenantId={tenantId}
                isAdmin
              />
            </Stack>
          </PivotItem>
          <PivotItem headerText="Parameters" itemKey="parameters">
            <Stack tokens={{ childrenGap: 12 }}>
              <Text variant="large">Tenant pricing parameters</Text>
              <Text>
                Tenant: {tenantName || tenantId}. Each parameter uses the global
                value, when one exists, until this tenant overrides it. Rates
                stay in Rate overrides.
              </Text>
              <TenantPricingParameters
                key={tenantId}
                tenantId={tenantId}
                isAdmin
              />
            </Stack>
          </PivotItem>
          <PivotItem
            headerText="Automatic surcharges"
            itemKey="automaticSurcharges"
          >
            <TenantSurcharges key={tenantId} tenantId={tenantId} />
          </PivotItem>
          <PivotItem
            headerText="Form availability"
            itemKey="reportAvailability"
          >
            <Stack tokens={{ childrenGap: 12 }}>
              <Text>Tenant: {tenantName || tenantId}.</Text>
              <TenantReportAvailability
                key={tenantId}
                tenantId={tenantId}
                selectedTenantId={tenantId}
              />
            </Stack>
          </PivotItem>
          <PivotItem headerText="Form categories" itemKey="formCategories">
            <Stack tokens={{ childrenGap: 12 }}>
              <Text>Tenant: {tenantName || tenantId}.</Text>
              <TenantReportAvailability
                key={tenantId}
                tenantId={tenantId}
                selectedTenantId={tenantId}
                categoriesOnly
              />
            </Stack>
          </PivotItem>
        </Pivot>
      )}
    </Stack>
  );
};

export default Pricing;
